/**
 * Function to get environment variable.
 * Needed because some envs are injected by `process.env` and some by `window.__env__` (depending on the build mode)
 * @param key - name of the env variable
 * @returns value of the env variable
 */
export const getEnv = (key: string): string | undefined => {
  if (window.__env__) {
    return window.__env__[key];
  }
  return process.env[key];
};
